import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styled from "styled-components";

import { getUrlVars, setCookie, getCookie, detectLang } from "./utils";
import Homepage from "./pages/homepage";
import Footer from "./components/Footer";
import { setLang, submitForm, setSubscriber } from "./redux/actions/main";
import content from "./content/copy";

const imgPrefix =
  "https://mgtool.data-m8agency.com/public/salesforce/htz/pages/2160";

const Container = styled.div`
  position: relative;
  display: block;
  width: 100%;
  min-height: 100vh;
  background: #f6f6f6;
  margin: 0 auto;
`;
const Layout = styled.div`
  width: 100%;
  max-width: 685px;
  margin: 0 auto;
  background: #fff;
  padding: 42px 0;
`;

class App extends Component {
  constructor(props) {
    super(props);

    // Setup Language
    this.lang = detectLang().lang;
    if (this.lang !== "en" && this.lang !== "es" && this.lang !== "pt") {
      this.lang = "en";
    }

    // Setup the Subscriber Key
    const subscriberKey = getUrlVars().sfid || getCookie("usersubscriberkey");
    if (!subscriberKey || subscriberKey === "") {
      console.error(
        `No SubscriberKey (${subscriberKey}) was found for this user!`
      );
      window.location.href = `https://www.hertz.com/rentacar/rental-car-deals`;
    }
    setCookie("usersubscriberkey", subscriberKey);

    // Check if the user already submitted the form
    const x = getCookie("formsubmitted");
    if (x.length > 0) props.submitform(true);
    props.setLanguage(this.lang);
    props.setSubscriberKey(subscriberKey);

    // Init the empty App State
    this.state = {};
  }

  render() {
    const { lang } = this.props;
    const copy = content[lang];
    return (
      <Container>
        <Layout>
          <Homepage {...{ imgPrefix, lang, copy }} />
        </Layout>
        <Footer {...{ imgPrefix, lang, copy }} />
      </Container>
    );
  }
}

App.defaultProps = {};
App.propTypes = {
  submitform: PropTypes.func.isRequired,
  setLanguage: PropTypes.func.isRequired,
  setSubscriberKey: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired
};

const mapDispatchToProps = dispatch => ({
  setSubscriberKey: subscriber => dispatch(setSubscriber(subscriber)),
  setLanguage: lang => dispatch(setLang(lang)),
  submitform: bool => dispatch(submitForm(bool))
});

const mapStateToProps = state => ({
  ...state.main
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
